module.exports = __webpack_public_path__ + "img/a1ebe08.png";